module.exports = __webpack_public_path__ + "static/media/epr_resort.06c0f959.png";